import React from 'react'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'About Us', href: '#about' },
    { name: 'Our Doctor', href: '#doctor' },
    { name: 'Services', href: '#services' },
    { name: 'Contact', href: '#contact' }
  ]

  const services = [
    'Panchakarma Therapy',
    'Abhyanga Massage',
    'Shirodhara',
    'Herbal Steam Bath',
    'Ayurvedic Consultation',
    'Yoga & Meditation'
  ]

  const contactInfo = [
    { icon: '📍', text: '' },
    { icon: '📞', text: '+91' },
    { icon: '✉️', text: 'info@sravaniayurdham.com' },
    { icon: '🕐', text: 'Mon-Sat: 9AM-7PM, Sun: 10AM-5PM' }
  ]

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-gradient-green rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-xl">🕉</span>
              </div>
              <span className="ml-3 text-2xl font-bold text-white">
                Sravani <span className="text-yellow-400">Ayurdham</span>
              </span>
            </div>
            <p className="text-gray-300 leading-relaxed">
              Experience the healing power of authentic Ayurveda. We combine ancient wisdom with modern care 
              to provide holistic wellness solutions for mind, body, and spirit.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center hover:bg-green-700 transition-colors duration-200">
                <span className="text-white">📘</span>
              </a>
              <a href="#" className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center hover:bg-green-700 transition-colors duration-200">
                <span className="text-white">📷</span>
              </a>
              <a href="#" className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center hover:bg-green-700 transition-colors duration-200">
                <span className="text-white">🐦</span>
              </a>
              <a href="#" className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center hover:bg-green-700 transition-colors duration-200">
                <span className="text-white">📺</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold text-white mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <a 
                    href={link.href}
                    className="text-gray-300 hover:text-green-400 transition-colors duration-200 flex items-center"
                  >
                    <span className="mr-2">▶</span>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-xl font-bold text-white mb-6">Our Services</h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <a 
                    href="#services"
                    className="text-gray-300 hover:text-green-400 transition-colors duration-200 flex items-center"
                  >
                    <span className="mr-2 text-green-400">🌿</span>
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold text-white mb-6">Contact Info</h3>
            <ul className="space-y-4">
              {contactInfo.map((info, index) => (
                <li key={index} className="flex items-start">
                  <span className="mr-3 mt-1 text-green-400">{info.icon}</span>
                  <span className="text-gray-300 text-sm leading-relaxed">{info.text}</span>
                </li>
              ))}
            </ul>
            
            {/* Newsletter Signup */}
            <div className="mt-6">
              <h4 className="text-lg font-semibold text-white mb-3">Newsletter</h4>
              <p className="text-gray-300 text-sm mb-3">Subscribe for wellness tips and updates</p>
              <div className="flex">
                <input
                  type="email"
                  placeholder="Your email"
                  className="flex-1 px-3 py-2 bg-gray-800 border border-gray-700 rounded-l-lg text-white placeholder-gray-400 focus:outline-none focus:border-green-400"
                />
                <button className="px-4 py-2 bg-green-600 hover:bg-green-700 rounded-r-lg transition-colors duration-200">
                  <span className="text-white">✉️</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-300 text-sm mb-4 md:mb-0">
              © {currentYear} Sravani Ayurdham. All rights reserved. 
              <span className="mx-2">|</span>
              <a href="#" className="hover:text-green-400 transition-colors duration-200">Privacy Policy</a>
              <span className="mx-2">|</span>
              <a href="#" className="hover:text-green-400 transition-colors duration-200">Terms of Service</a>
            </div>
            <div className="text-gray-300 text-sm">
              Designed with 💚 for natural wellness
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
